import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { BlogPostSiblingsBlock } from '../../_blocks/BlogPostSiblings';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';

export type BlogPostSiblingsWidget = ContextWidget<BlogPostSiblingsBlock, WidgetType.blogpostsiblings>;

export function BlogPostSiblingsWidget(props: BlogPostSiblingsWidget) {
  const { t } = useSonTranslation('Blogs');
  return <DefaultContextWidget icon={Icons.INTERNAL_LINK_ARROW} title={t('siblings.widgetTitle')} {...props} />;
}
